import { plainToClass } from "class-transformer";

class Header {
  text: string = "";
  value: string = "";
}

class Value {
  id?: number;
  name: string = "";
  risk?: number = 0;
  co2?: number = 0;
}

class Pagination {
  sortBy: string = "";
  descending: boolean = true;
}

export default class Category {
  name: string = '';
  type: string = '';
  headers: Header[];
  values: Value[];
  loading: boolean = false;
  pagination: Pagination;
  customSort: boolean = false;
  rowsPerPageItems: any = [-1];
  hideActions: boolean = true;
  deleteDialogWidth: number = 290;
  deleteWarning: string = '';

  createQuery: any;
  createAttribute: string;
  editQuery: any;
  editAttribute: string;
  deleteQuery: any;
  deleteAttribute: string;
  deleteRefetchQuery: any;

  listQuery: any;
  listAttribute: string;

  valueAttribute: string;

  create(apollo: any, input: Value) {
    let optimisticResponse = {
      __typename: 'Mutation',
    };

    optimisticResponse[this.createAttribute] = {
      __typename: this.type,
      id: -1,
      ...input,
    };

    apollo.mutate({
      mutation: this.createQuery,
      variables: { input },
      update: (store, { data: updateData }) => {
        const newValue = updateData[this.createAttribute];
        let data: any = store.readQuery({
          query: this.listQuery,
        });

        data[this.listAttribute].push(newValue);

        store.writeQuery({
          query: this.listQuery,
          data,
        });
      },
      optimisticResponse,
    });
  }

  edit(apollo: any, input: Value, id: number) {
    let optimisticResponse = {
      __typename: 'Mutation',
    };

    optimisticResponse[this.editAttribute] = {
      __typename: this.type,
      id: -1,
      ...input,
    };

    apollo.mutate({
      mutation: this.editQuery,
      variables: { input },
      update: (store, {data: updateData}) => {
        const newValue = updateData[this.editAttribute];
        let data: any = store.readQuery({
          query: this.listQuery,
        });

        data[this.listAttribute] = data[this.listAttribute].filter(
          value => value.id !== id
        );

        data[this.listAttribute].push(newValue);

        store.writeQuery({
          query: this.listQuery,
          data,
        });
      },
      optimisticResponse,
    });
  }

  delete(apollo: any, id: number) {
    let optimisticResponse = {
      __typename: 'Mutation',
    };

    optimisticResponse[this.deleteAttribute] = id;

    apollo.mutate({
      mutation: this.deleteQuery,
      variables: { id: id },
      update: (store, {data: updateData}) => {
        const deleteId = updateData[this.deleteAttribute];
        let data: any = store.readQuery({
          query: this.listQuery,
        });

        data[this.listAttribute] = data[this.listAttribute].filter(
          value => value.id !== deleteId
        );

        store.writeQuery({
          query: this.listQuery,
          data,
        });
      },
      optimisticResponse,
      refetchQueries: this.deleteRefetchQuery != null ? [{ query: this.deleteRefetchQuery }] : [],
    });
  }

  generateSortMethod() {
    const type = this.type;
    return (items, index, isDescending) => {
      const modifier = (isDescending ? -1 : 1);
      return items.sort( (item1, item2) => {
        if (!index)
          return 0;

        const value1 = item1[index];
        const value2 = item2[index];

        if (index === 'name' && type === 'StorageCondition') {
          const firstLetter1 = value1.charAt(0);
          const firstLetter2 = value2.charAt(0);
          let firstLetter = firstLetter1.localeCompare(firstLetter2);
          const risk1 = item1.risk;
          const risk2 = item2.risk;
          const risk  = risk1 - risk2;

          // Force hot to be last.
          if (firstLetter1 === 'H' && firstLetter !== 0)
            firstLetter = 1;

          if (firstLetter2 === 'H' && firstLetter !== 0)
            firstLetter = -1;

          if (firstLetter !== 0)
            return modifier * firstLetter;
          else
            return modifier * risk;
        } else {
          if (isFinite(value1) && isFinite(value2))
            return modifier * (value1 - value2);

          return modifier * value1.toString().localeCompare(value2);
        }
      });
    }
  }

  static restore(eCategory: any) {
    let category = plainToClass<Category, Object>(Category, eCategory)
    return category;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/tables/category.ts